import React from "react";
import { useParams } from "react-router-dom";
import { useApi } from "../lib/useApi";
import sanitiseHtml from "./sanitiseHtml";

const FullPreview = () => {
  const { id } = useParams();
  const { data: previews } = useApi(`/api/GetFullPreview/${id}`, { select: (json) => json.value });
  const Preview = previews ? previews[0] : {};

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        <div className="panel">
          <h3>{Preview.title}</h3>
          <p dangerouslySetInnerHTML={{ __html: sanitiseHtml(Preview.content) }} />
        </div>
      </div>
    </div>
  );
};

export default FullPreview;
